import {
    Button,
    Form,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Spinner, Table
} from "reactstrap";
import {useFormik} from "formik"
import * as yup from "yup"
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    massMessageTempDelete,
    massMessageTempDeleteReset,
    massMessageTempLoad,
    massMessageTempSave,
    massMessageTempSaveReset
} from "../../redux/actions/BrandActions";
import {
    successAlert,
    errorAlert,
    confirmAlert
} from './CustomAlerts'
import {ArrowLeftCircle, XCircle} from "react-feather";

const MsgTemplates = ({
                          showSaveModal,
                          template,
                          closeModal,
                          templateType,
                          showTemplatesModal,
                          applyTemplate
                      }) => {

    const dispatch = useDispatch()

    const [openSaveModal, setOpenSaveModal] = useState(false)
    const [openTemplatesModal, setOpenTemplatesModal] = useState(false)

    const {
        rdGroupListLoading,
        rdGroupListData,
        rdGroupListError,

        massMsgTempSaveLoading,
        massMsgTempSaveData,
        massMsgTempSaveError,

        massMsgTempListLoading,
        massMsgTempListData,
        massMsgTempListError,

        massMsgTempDeleteLoading,
        massMsgTempDeleteData,
        massMsgTempDeleteError
    } = useSelector(state => state.brandReducer)

    const saveForm = useFormik({
        initialValues: {
            title: "",
            message: ""
        },
        validationSchema: yup.object().shape({
            title: yup.string().trim().required("This field is required"),
            message: yup.string().trim().required("This field is required")
        }),
        onSubmit: (values) => {
            const obj = {
                title: values.title,
                template: values.message
            }
            if (templateType === 'mass') {
                obj.type = 'mass'
            }
            dispatch(massMessageTempSave(obj))
        }
    })

    const {
        handleSubmit,
        values,
        handleBlur,
        handleChange,
        touched,
        errors,
        resetForm,
        setFieldValue
    } = saveForm

    useEffect(() => {
        dispatch(massMessageTempLoad(''))
    }, []);

    useEffect(() => {
        setOpenSaveModal(showSaveModal)
        setFieldValue('message', template)
    }, [
        showSaveModal,
        template
    ]);

    useEffect(() => {
        setOpenTemplatesModal(showTemplatesModal)
    }, [
        showTemplatesModal
    ]);

    useEffect(() => {
        if (massMsgTempSaveData?.success) {
            successAlert(massMsgTempSaveData?.msg)
            resetForm()
            closeModal()
            dispatch(massMessageTempLoad("?type=mass"))
            dispatch(massMessageTempSaveReset())
        }

        if (massMsgTempSaveError?.response?.status) {
            const errorHTML = ['<ul class="list-group">']
            if (massMsgTempSaveError?.response?.data?.errors?.title) {
                errorHTML.push(`<li class="list-group-item font-small-3 text-danger">${massMsgTempSaveError?.response?.data?.errors?.title[0]}</li>`)
            }
            errorHTML.push('</ul>')
            errorAlert(errorHTML.join(''))
            dispatch(massMessageTempSaveReset())
        }

        if (massMsgTempDeleteData?.success) {
            successAlert(massMsgTempDeleteData?.msg)
            dispatch(massMessageTempLoad("?type=mass"))
            dispatch(massMessageTempDeleteReset())
        }
    }, [
        massMsgTempSaveData,
        massMsgTempSaveError,
        massMsgTempListData,
        massMsgTempDeleteData
    ])

    const deleteMassMsgTemp = async (data) => {
        const result = await confirmAlert('Confirm!', 'Do you want to delete this template?')
        if (result) {
            dispatch(massMessageTempDelete({
                id: data.id
            }))
        }
    }

    return (
        <>
            <Modal isOpen={openSaveModal} className='modal-lg modal-dialog-centered'>
                <ModalHeader>Save Template</ModalHeader>
                <Form onSubmit={handleSubmit} autoComplete="off">
                    <ModalBody style={{minHeight: '50px'}}>
                        <FormGroup className='mb-2'>
                            <Label htmlFor='massMsgTempTitle'><strong>Title</strong></Label>
                            <Input type="text"
                                   placeholder='Title'
                                   id="massMsgTempTitle"
                                   name="title"
                                   value={values.title}
                                   onBlur={handleBlur}
                                   onChange={handleChange}
                                   disabled={massMsgTempSaveLoading}
                            />
                            <div className="validation-err">
                                {touched.title && errors.title}
                            </div>
                        </FormGroup>
                        <FormGroup className='mb-2'>
                            <Label htmlFor='massMsgTempMsg'><strong>Message</strong></Label>
                            <div className='bg-light p-1 border'
                                 dangerouslySetInnerHTML={{__html: values.message}}></div>
                            <div className="validation-err">
                                {touched.message && errors.message}
                            </div>
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter className='d-flex justify-content-between'>
                        <Button color='danger' outline onClick={() => {
                            closeModal()
                            resetForm()
                        }} disabled={massMsgTempSaveLoading}>
                            Cancel
                        </Button>
                        <Button color='primary' type='submit' disabled={massMsgTempSaveLoading}>
                            {massMsgTempSaveLoading ? (
                                <Spinner style={{height: '14px', width: '14px'}}/>
                            ) : (
                                <span>Save</span>
                            )}
                        </Button>
                    </ModalFooter>
                </Form>
            </Modal>

            <Modal isOpen={openTemplatesModal} className='modal-lg modal-dialog-centered'>
                <ModalHeader>
                    Templates
                </ModalHeader>
                <ModalBody style={{minHeight: '50px'}}>
                    <Table responsive>
                        <thead>
                        <tr>
                            <th>Title</th>
                            <th width={300}>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        {massMsgTempListLoading ? (
                            <tr>
                                <td colSpan='3' className='text-center'><strong>Please wait...</strong></td>
                            </tr>
                        ) : (
                            massMsgTempListData?.data?.length > 0 ? (
                                massMsgTempListData?.data?.some(item => item?.type === templateType) ? (
                                    massMsgTempListData?.data?.map((item, index) => (
                                        item?.type === templateType && (
                                            <tr key={index}>
                                                <td>{item?.title?.length > 20 ? `${item?.title?.substring(0, 20)}...` : item?.title}</td>
                                                <td className='text-center'>
                                                    <button className='btn btn-primary btn-sm mr-1'
                                                            onClick={() => {
                                                                applyTemplate(item)
                                                                closeModal()
                                                            }}
                                                            disabled={massMsgTempDeleteLoading}
                                                    >
                                                        <ArrowLeftCircle size={14}/> Apply
                                                    </button>
                                                    <button className='btn btn-danger btn-sm'
                                                            onClick={() => {
                                                                deleteMassMsgTemp(item).then(r => r)
                                                            }}
                                                            disabled={massMsgTempDeleteLoading}
                                                    >
                                                        <XCircle size={14}/> Delete
                                                    </button>
                                                </td>
                                            </tr>
                                        )
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan='3' className='text-center'><strong>No templates found.</strong></td>
                                    </tr>
                                )
                            ) : (
                                <tr>
                                    <td colSpan='3' className='text-center'><strong>No templates found.</strong></td>
                                </tr>
                            )
                        )}
                        </tbody>
                    </Table>
                </ModalBody>
                <ModalFooter className='d-flex justify-content-end'>
                    <Button color='primary' onClick={() => {
                        closeModal()
                    }} disabled={massMsgTempSaveLoading}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    )
}

export default MsgTemplates